import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

export default function CoverageDisclaimer() {
  return (
    <div className="glp1-disclaimer">
      <InfoCircleOutlined style={{ marginTop: 2 }} />
      <div>
        <div className="glp1-disclaimer-title">Not a final coverage determination</div>
        <p>
          Use this as CMS-source workflow guidance. Individual coverage and clinical decisions still
          require the applicable CMS, plan, and patient-specific review.
        </p>
      </div>
    </div>
  );
}
